<template>

  <div class="server-list">

    <h2>{{ $t('title.servers') }}</h2>

    <data-table
      :model="servers"
      :columns="['fqdn', 'description']"
      :operations="operations" />

    <el-dialog :title="$t('title.activate-server')" v-model="showActivateDialog">
      <data-form
        :entity="serverToActivate"
        :fields="activateFields"
        :cancelAction="cancelActivation"
        @submit="activateServer" />
    </el-dialog>

    <el-dialog :title="$t('title.inactivate-server')" v-model="showInactivateDialog">
      <span>{{ $t('message.incativate-server') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="inactivateServer">{{ $t('button.inactivate' ) }}</el-button>
        <el-button @click="showInactivateDialog = false">{{ $t('button.cancel' ) }}</el-button>
      </span>
    </el-dialog>

  </div>

</template>

<script>
import { post } from 'providers/http'
import { CHILD_SERVER_DETAILS } from 'router/routes'

export default {
  name: 'server-list',
  props: {
    'servers': {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      showActivateDialog: false,
      showInactivateDialog: false,
      serverToActivate: null,
      serverToInactivate: null,
      activateFields: {
        'passphrase': {
          type: 'text',
          rules: [{ required: true }]
        }
      }
    }
  },
  computed: {
    operations () {
      return [
        {
          label: 'activate',
          method: this._activateOperation,
          permission: ['ACTIVATE_SERVER', 'id'],
          precondition: server => !server.connected
        },
        {
          label: 'inactivate',
          type: 'danger',
          icon: 'delete',
          method: this._inactivateOperation,
          permission: ['INACTIVATE_SERVER', 'id'],
          precondition: server => server.connected
        },
        {
          label: 'details',
          method: this._detailsOperation,
          permission: ['VIEW_SERVERS', 'id'],
          precondition: server => server.connected
        }
      ]
    }
  },
  methods: {
    _activateOperation (server) {
      this.serverToActivate = server
      this.showActivateDialog = true
    },
    async activateServer ({ id, passphrase }) {
      try {
        await post('api/v1/servers/activate', { id, passphrase })

        // This is here only for faster UI reaction
        this.serverToActivate.connected = true
      }
      catch (err) {
        console.error(err)
      }

      this.serverToActivate = {}
      this.showActivateDialog = false
    },
    cancelActivation () {
      this.showActivateDialog = false
    },
    _inactivateOperation (server) {
      this.serverToInactivate = server
      this.showInactivateDialog = true
    },
    async inactivateServer () {
      try {
        await post('api/v1/servers/inactivate', { id: this.serverToInactivate.id })

        // This is here only for faster UI reaction
        this.serverToInactivate.connected = false
      }
      catch (err) {
        console.error(err)
      }

      this.serverToInactivate = {}
      this.showInactivateDialog = false
    },
    _detailsOperation (server) {
      this.$router.push({ name: CHILD_SERVER_DETAILS, params: { 'id': server.id } })
    }
  }
}
</script>


// WEBPACK FOOTER //
// ServerList.vue?3043b65c